export const File = '_file'

export const Folder = '_folder'

export const FolderOpen = '_folder_open'

export const None = ''
